













































































































































































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import Sticky from 'vue-sticky-directive';
import {
  PartnersApi, DocumentRequest, Partner, PartnerOnboarding, PartnerOnboardingStatusEnum,
  UserApi,
} from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import ToastModule from '@/store/modules/toast';
import UserModule from '@/store/modules/user';
import Documents from '@/components/Form/FileUploadForm/Documents/index.vue';
import Sidebar from '@/views/partners/sidebar.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import PartnerSticky from '@/components/PartnerSticky/index.vue';
import ApprovePartner from '@/components/Modal/ApprovePartner/index.vue';
import PartnerSubmitOnboard from '@/components/Modal/PartnerSubmitOnboard/index.vue';
import PartnerUtil from '@/util/PartnerUtil';
import PartnerStatusIcon from '@/components/PartnerStatusIcon/index.vue';
import StandardCard from '@/components/Card/StandardCard/index.vue';
import AccountActivation from '@/components/AccountActivation/index.vue';
import Service from '@/util/ServiceUtil';
import { IRestaurantUserInfo, IFwManagerInfo } from '@/interface/userTableInfo';

@Component({
  components: {
    Sidebar,
    Documents,
    PrimaryButton,
    PartnerSticky,
    ApprovePartner,
    PartnerSubmitOnboard,
    PartnerStatusIcon,
    StandardCard,
    AccountActivation,
  },
  directives: { Sticky },
})
export default class PartnerDocumentsList extends Vue {
  private partnerID: string = '';

  private documents: Array<DocumentRequest> | null = null;

  private partnerName: string = '';

  public partnerDisable: boolean = true;

  public showPartnerModal: boolean = false;

  public showPartner: boolean = false;

  public loading: boolean = false;

  public saving: boolean = false;

  public restaurantName: string = '';

  public status: PartnerOnboardingStatusEnum | null = null ;

  public userFormatted: string = '';

  public error: string = '';

  public submissionFeed: string = '';

  public partnerType: string = '';

  public activationLoader: boolean = false;

  public restarantPartnerInfo: IRestaurantUserInfo = {
    restPartnerEmail: '',
    is: '',
  };

  public scoutUserInfo: IFwManagerInfo = {
    scoutUserEmail: '',
    is: '',
  }

  public mounted() {
    this.getDocuments();
    this.getPartnerName();
  }

  public updated() {
    this.getOnBoardingPartnerStatus();
  }

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }


  private attachementsInfo: any = {
    parterAgreement: false,
    questionnaire: false,
    wnine: false,
    insurance: false,
    businessLicense: false,
    healthPermit: false,
    healthInspection: false,
    serveSafe: false,
    allergenManagementCertificate: false,
  };

  public agreementFile: any = {
    url: '/assets/Restaurant contract.pdf',
    name: 'Restaurant contract.pdf',
  };

  public agreementFileFoodtruck: any = {
    url: '/assets/FoodTrucks contract.pdf',
    name: 'FoodTrucks contract.pdf',
  };

  public safetQuestionaieFile: any = {
    url: '/assets/FSQ.pdf',
    name: 'FSQ.pdf',
  };

  public insuranceFile: any = {
    url: '/assets/COI Sample.pdf',
    name: 'COI Sample.pdf',
  };

  public async getDocuments() {
    const { id } = this.$route.params;
    this.partnerID = id;
    try {
      const api = new PartnersApi(AppModule.apiConfig);
      const docs = await api.getPartnerDocuments(id);
      const { documents } = docs.data;
      ((this.documents) as any) = documents;
    } catch {
      this.documents = [];
    }
  }

  get canApprove() {
    const userStatus = Service.approverUser();
    return (
      userStatus
      && !this.onBoardingPartnerID
      && this.status !== PartnerOnboardingStatusEnum.Completed
    );
  }

  public get getAcceptedDoc() {
    const userStatus = Service.approverUser();
    const docs: any = !this.documents
    || this.documents.filter((doc) => doc.status === 'accepted');
    if (docs.length === this.documents?.length && userStatus) {
      return true;
    }
    return false;
  }

  public async getPartnerName() {
    const { id } = this.$route.params;
    try {
      const api = new PartnersApi(AppModule.apiConfig);
      const partnerData = await api.getPartnerById(id);
      const partner = partnerData.data;
      const { ownerUserId, scoutUserId } = partnerData.data;
      this.getPartnerUserInfo(ownerUserId as string, scoutUserId as string);
      ((this.status) as any) = partner.onboarding!.status;
      this.userFormatted = PartnerUtil.getPartnerStatusColor((this.status) as string);
      ((this.restaurantName) as any) = partner.name;
      (this.partnerType as any) = partner.type;
    } catch {
      //
    }
    return '';
  }

  public async getPartnerUserInfo(partnerUserID: string, scoutUserID: string) {
    const userApi = new UserApi(AppModule.apiConfig);
    const users = await Promise.all(
      [(userApi.getUser(partnerUserID)), (userApi.getUser(scoutUserID))],
    );
    const userInfo = !users || users.map((response) => response.data);
    if (userInfo) {
      const partnerUser = userInfo[0];
      const scoutUser = userInfo[1];
      const { email, is } = partnerUser;
      this.restarantPartnerInfo.is = is;
      this.restarantPartnerInfo.restPartnerEmail = email as string;
      this.scoutUserInfo.scoutUserEmail = scoutUser.email as string;
      this.scoutUserInfo.is = scoutUser.is;
    }
    return null;
  }

  get onBoardingPartnerID() {
    if (UserModule.currentPartner && UserModule.currentPartner.id) {
      return UserModule.currentPartner.id;
    }
    return '';
  }

  // get the partner status
  public async getOnBoardingPartnerStatus() {
    if (
      UserModule.currentPartner
      && UserModule.currentPartner.id === this.partnerID
    ) {
      try {
        const api = new PartnersApi(AppModule.apiConfig);
        const partnerData = await api.getPartnerById(this.partnerID);
        const { onboarding } = partnerData.data;
        const userStatus = onboarding!.status;
        if (userStatus === 'awaitPartner') {
          this.partnerDisable = false;
          return this.partnerDisable;
        }
        this.partnerDisable = true;
        return this.partnerDisable;
      } catch {
        //
      }
    }
    return null;
  }

  // Open the modal
  public onPartnerApprove() {
    this.showPartnerModal = true;
  }

  // Approve the partner restaurant name
  public async onApproveRestaurantName() {
    this.loading = true;
    const data: any = {
      status: PartnerOnboardingStatusEnum.Completed,
    };
    try {
      const api = new PartnersApi(AppModule.apiConfig);
      const partners = await api.updatesPartnerOnboarding(this.partnerID, data);
      (this.status as any) = PartnerOnboardingStatusEnum.Completed;
      this.userFormatted = PartnerUtil.getPartnerStatusColor(this.status as string);
      if (this.restaurantName) {
        ToastModule.setToast({
          message: `${this.restaurantName} has been approved`,
          timeout: 2000,
        });
      }
    } catch (err) {
      this.error = err.error;
    }
    this.loading = false;
    this.showPartnerModal = false;
    return '';
  }

  public cancelApprove() {
    this.showPartnerModal = false;
    this.showPartner = false;
  }

  // Requires review button click
  public async onPartnerReview() {
    this.loading = true;
    const data: any = {
      status: PartnerOnboardingStatusEnum.AwaitPartner,
    };
    try {
      const api = new PartnersApi(AppModule.apiConfig);
      const partners = await api.updatesPartnerOnboarding(this.partnerID, data);
      (this.status as any) = PartnerOnboardingStatusEnum.AwaitPartner;
      this.userFormatted = PartnerUtil.getPartnerStatusColor(this.status as string);
      ToastModule.setToast({
        message: `${this.restaurantName} status changed to Pending Partner Response`,
        timeout: 2000,
      });
    } catch (err) {
      this.error = err.error;
    }
    this.loading = false;
  }

  // onboarding partner modal open
  public onSubmit() {
    this.showPartner = true;
  }

  // onboarding partner submit
  public async onSubmitPartner() {
    this.loading = true;
    const data: any = {
      status: PartnerOnboardingStatusEnum.AwaitScout,
    };
    try {
      const api = new PartnersApi(AppModule.apiConfig);
      const partners = await api.updatesPartnerOnboarding(this.partnerID, data);
      (this.status as any) = PartnerOnboardingStatusEnum.AwaitScout;
      this.userFormatted = PartnerUtil.getPartnerStatusColor(this.status as string);
      ToastModule.setToast({
        message: 'Changes submitted for review',
        timeout: 2000,
      });
      this.submissionFeed = 'Your submission is being reviewed';
    } catch (err) {
      this.error = err.error;
    }
    this.loading = false;
    this.showPartner = false;
    return '';
  }

  public async sendInvitation(userEmail: string, userProfile: string) {
    if (userProfile === 'restPartner') {
      this.activationLoader = true;
    }
    if (userProfile === 'fwmanager') {
      this.saving = true;
    }
    const user: any = await Service.sendInvitation(userEmail);
    if (user.status === 200) {
      ToastModule.setToast({
        message: 'Sign up invitation has been sent',
        timeout: 5000,
      });
    } else {
      ToastModule.setToast({
        message: user.errorMessage,
        timeout: 5000,
      });
    }
    if (userProfile === 'restPartner') {
      this.activationLoader = false;
    }
    this.saving = false;
  }
}
